import { pinia } from '@/plugins/pinia'
import { Pinia } from 'pinia'
import { Ref, ref } from 'vue'

export const globalLoading = ref<boolean>(false)

type UseLoadingOptions = {
  global?: boolean
  store?: string
}

type UseLoadingReturn = {
  loading: Ref<boolean>
  globalLoading: Ref<boolean>
}

export function useLoading(): UseLoadingReturn
export function useLoading<T>(
  promise: (loading?: Ref<boolean>) => Promise<T>,
  options?: UseLoadingOptions
): Promise<T>
export function useLoading<T>(
  promise?: ((loading?: Ref<boolean>) => Promise<T>) | undefined,
  options?: UseLoadingOptions
): UseLoadingReturn | Promise<T> {
  const loading = ref<boolean>(false)
  const { global, store = 'account' } = options || {}

  if (!promise) {
    return {
      loading,
      globalLoading,
    }
  }

  loading.value = true

  if (global) {
    globalLoading.value = true
  }

  if (store && pinia.state.value[store as keyof Pinia]) {
    pinia.state.value[store as keyof Pinia].loading = true
  }

  return promise(loading).finally(() => {
    loading.value = false

    if (global) {
      globalLoading.value = false
    }

    if (store && pinia.state.value[store as keyof Pinia]) {
      pinia.state.value[store as keyof Pinia].loading = false
    }
  })
}
